import { render, staticRenderFns } from "./VictoryPrintPage.vue?vue&type=template&id=0f2a3f66&scoped=true&lang=pug&"
import script from "./VictoryPrintPage.vue?vue&type=script&lang=ts&"
export * from "./VictoryPrintPage.vue?vue&type=script&lang=ts&"
import style0 from "./VictoryPrintPage.vue?vue&type=style&index=0&id=0f2a3f66&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a3f66",
  null
  
)

export default component.exports